// extracted by mini-css-extract-plugin
export default {"listagem":"DadosApi_listagem__orI-J","loading":"DadosApi_loading__dKe85","msgErro":"DadosApi_msgErro__VMdiI","marcadorCarregamento":"DadosApi_marcadorCarregamento__VaaC7"};